import { bootstrapApplication } from '@angular/platform-browser';
import { setWorkerUrl } from 'maplibre-gl';
import { appConfig } from './app/app.config';
import { AppComponent } from './app/app.component';

setWorkerUrl(new URL('maplibre-gl-worker.mjs', import.meta.url).href);

bootstrapApplication(AppComponent, appConfig)
  .catch((err) => console.error(err));
